module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Child', {
    key: _vm.item.id,
    attrs: {
      "id": _vm.item.id,
      "modal": _vm.modal,
      "index": _vm.index,
      "age": _vm.item.age,
      "gender": _vm.item.sex,
      "name": _vm.item.first_name,
      "surname": _vm.item.last_name,
      "active": _vm.selector === _vm.index,
      "modules": _vm.modules,
      "isProgress": _vm.isProgress,
      "isPfdod": _vm.isPfdod,
      "isApproved": _vm.item.is_approved
    },
    on: {
      "editChild": _vm.childEvent
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4766370","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/ChildrenList.vue
// module id = 5d98f7ec1cb4b168ebd3
// module chunks = 89